import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { joinAbsRoute } from 'src/common/utils'
import { ROUTES } from 'src/constants'

import { accountsService } from 'src/services/accounts.service'

export const useCreateAccountCheckAccept = () => {
  const navigate = useNavigate()

  return useMutation((accountId: string) => accountsService.createAccountCheckAccept(accountId), {
    onSuccess(data, variable) {
      if (!data) return

      navigate(joinAbsRoute(ROUTES.ACCOUNTS, variable, ROUTES.DASHBOARD))
    },
  })
}
